import React from 'react';
const vols = [{
  n: '01',
  fill: '#1C6DD0',
  angle: -30
}, {
  n: '02',
  fill: '#10233A',
  angle: -18
}, {
  n: '03',
  fill: '#17B26A',
  angle: -6
}, {
  n: '04',
  fill: '#FF5A4D',
  angle: 6
}, {
  n: '05',
  fill: '#1557A8',
  angle: 18
}, {
  n: '06',
  fill: '#0E8A51',
  angle: 30
}];
const font = 'Poppins, system-ui, sans-serif';

/** Fallback pack visual, shown while no mockup image URL is set. */
export function PackIllustration({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 600 400" role="img" aria-label="Badminton Class Ready: six volumes fanned out" className={`w-full h-auto ${className}`} data-id="element-170" data-mp="3b2r2j9w6q3x8">
      <circle cx="300" cy="230" r="180" fill="#E4EFFC" data-id="element-171" data-mp="2x9hy7nn3g8lk" />
      <g stroke="#1C6DD0" strokeOpacity="0.18" strokeWidth="2" fill="none" data-id="element-172" data-mp="32bqqsiw218n5">
        <rect x="120" y="60" width="360" height="320" rx="4" data-id="element-173" data-mp="2ncwquvnlqlek" />
        <line x1="110" y1="220" x2="490" y2="220" strokeWidth="4" data-id="element-174" data-mp="2nfhrjhc5yvaq" />
        <line x1="300" y1="60" x2="300" y2="175" data-id="element-175" data-mp="2sb6nzbsvzw2t" />
        <line x1="300" y1="265" x2="300" y2="380" data-id="element-176" data-mp="20r9jn0spy67o" />
      </g>
      {vols.map(v => <g key={v.n} transform={`rotate(${v.angle} 300 470)`} data-id="element-177" data-mp="20t2me507o6ae">
          <rect x="231" y="124" width="140" height="196" rx="12" fill="#10233A" opacity="0.18" data-id="element-178" data-mp="1vrn3aihlg9un" />
          <rect x="230" y="120" width="140" height="196" rx="12" fill={v.fill} data-id="element-179" data-mp="29rec84t9701s" />
          <rect x="230" y="120" width="140" height="42" rx="12" fill="#FFFFFF" fillOpacity="0.14" data-id="element-180" data-mp="25rdyynhw4uwb" />
          <text x="244" y="139" fontSize="9" fontWeight="700" fill="#FFFFFF" fontFamily={font} letterSpacing="1" data-id="element-181" data-mp="1i1tdnxy9lljv">
            BADMINTON
          </text>
          <text x="244" y="153" fontSize="11" fontWeight="800" fill="#FFC93C" fontFamily={font} data-id="element-182" data-mp="1czudewxtn4r5">
            CLASS READY
          </text>
          <g stroke="#FFFFFF" fill="none" data-id="element-183" data-mp="1m23hb3yl3zvk">
            <rect x="262" y="174" width="76" height="104" strokeOpacity="0.6" strokeWidth="1.5" data-id="element-184" data-mp="1m08wrqr869s0" />
            <line x1="256" y1="226" x2="344" y2="226" strokeWidth="3" data-id="element-185" data-mp="yaod15n8z8ho" />
            <line x1="262" y1="208" x2="338" y2="208" strokeOpacity="0.45" data-id="element-186" data-mp="uaea61ur4y71" />
            <line x1="262" y1="244" x2="338" y2="244" strokeOpacity="0.45" data-id="element-187" data-mp="2tgpfa0ybek3h" />
            <line x1="300" y1="174" x2="300" y2="208" strokeOpacity="0.45" data-id="element-188" data-mp="2yeqwshg3ebcu" />
            <line x1="300" y1="244" x2="300" y2="278" strokeOpacity="0.45" data-id="element-189" data-mp="2ycxrb5h7tx6f" />
            <path d="M285 260 Q 255 220 312 190" strokeDasharray="3 4" strokeOpacity="0.9" data-id="element-190" data-mp="3368xd4e7e9xa" />
          </g>
          <circle cx="285" cy="260" r="4.5" fill="#FFC93C" data-id="element-191" data-mp="38422du3rsxvz" />
          <circle cx="312" cy="190" r="4.5" fill="#FFFFFF" data-id="element-192" data-mp="2ahv04quxvhms" />
          <text x="244" y="304" fontSize="12" fontWeight="800" fill="#FFFFFF" fontFamily={font} data-id="element-193" data-mp="2ajfuafdccyk4">
            VOL. {v.n}
          </text>
        </g>)}
      <circle cx="512" cy="88" r="48" fill="#FFC93C" data-id="element-194" data-mp="2keg6bfip2ys7" />
      <text x="512" y="92" textAnchor="middle" fontSize="30" fontWeight="800" fill="#10233A" fontFamily={font} data-id="element-195" data-mp="2pe2hzkivk6yw">
        77
      </text>
      <text x="512" y="110" textAnchor="middle" fontSize="9" fontWeight="700" fill="#10233A" fontFamily={font} letterSpacing="1" data-id="element-196" data-mp="3vtcy2x69k239">
        SESSIONS
      </text>
    </svg>;
}